<template>
  <div class="viluu-landing viluu-landing--err err-page">
    <bg-blobs />

    <div
      class="drift"
      aria-hidden="true"
    >
      <span
        v-for="(h, i) in hearts"
        :key="i"
        class="h"
        :style="h.style"
        ><icon-heart
      /></span>
    </div>

    <nav class="nav">
      <a
        href="/"
        class="logo"
        :aria-label="trans.get('landing.nav.home_aria')"
      >
        <img
          class="logo-wordmark"
          src="../../../../../../images/viluu/landing-v2/viluu-wordmark.svg"
          :alt="trans.get('landing.common.wordmark_alt')"
        />
      </a>
    </nav>

    <main class="err-main">
      <div
        class="err-glyph"
        aria-hidden="true"
      >
        <span
          class="d left"
          data-d="4"
          >4</span
        >
        <span class="err-heart">
          <icon-heart />
          <span class="crack"><icon-heart-crack /></span>
          <span class="sparkle sp1">✦</span>
          <span class="sparkle sp2">✦</span>
          <span class="sparkle sp3">✦</span>
        </span>
        <span
          class="d right"
          data-d="4"
          >4</span
        >
      </div>

      <h1 class="err-h1">
        {{ trans.get('landing.subpages.not_found.title_prefix')
        }}<span class="grad">{{ trans.get('landing.subpages.not_found.title_grad') }}</span
        >{{ trans.get('landing.subpages.not_found.title_suffix') }}
      </h1>
      <p class="err-sub">{{ trans.get('landing.subpages.not_found.sub') }}</p>

      <div class="err-actions">
        <a
          class="btn-primary"
          href="/"
          >{{ trans.get('landing.subpages_shared.cta_back_home') }} <span class="arrow">→</span></a
        >
        <button
          type="button"
          class="btn-ghost"
          @click="openSignup"
        >
          {{ trans.get('landing.subpages_shared.cta_register_free') }}
        </button>
      </div>

      <div class="err-quick">
        <h6>{{ trans.get('landing.subpages.not_found.where_label') }}</h6>
        <a href="/#quiz-match"
          ><span>{{ trans.get('landing.subpages.not_found.link_quiz') }}</span
          ><span class="arr">→</span></a
        >
        <a href="/#top-choice"
          ><span>{{ trans.get('landing.subpages.not_found.link_topchoice') }}</span
          ><span class="arr">→</span></a
        >
        <a href="/faq"
          ><span>{{ trans.get('landing.subpages.not_found.link_help') }}</span
          ><span class="arr">→</span></a
        >
        <a href="/impressum"
          ><span>{{ trans.get('landing.subpages.not_found.link_imprint') }}</span
          ><span class="arr">→</span></a
        >
      </div>
    </main>

    <div class="err-foot">
      <span>{{ trans.get('landing.subpages.not_found.copyright', { year }) }}</span>
      <span class="err-foot-sep">·</span>
      <a href="/impressum">{{ trans.get('landing.footer.imprint') }}</a>
      <a href="/agb">{{ trans.get('landing.footer.agb') }}</a>
      <a href="/datenschutz">{{ trans.get('landing.footer.privacy') }}</a>
    </div>

    <signup-modal />
  </div>
</template>

<script>
import BgBlobs from '../../../../components/LandingV2/BgBlobs.vue';
import SignupModal from '../../../../components/LandingV2/signup/SignupModal.vue';
import IconHeart from '../../../../components/LandingV2/icons/IconHeart.vue';
import IconHeartCrack from '../../../../components/LandingV2/icons/IconHeartCrack.vue';

export default {
  name: 'NotFoundPage',
  components: { BgBlobs, SignupModal, IconHeart, IconHeartCrack },
  data() {
    return {
      hearts: [],
      year: new Date().getFullYear(),
    };
  },
  mounted() {
    document.body.classList.add('viluu-landing-body');
  },
  beforeDestroy() {
    document.body.classList.remove('viluu-landing-body');
  },
  created() {
    const N = 14;
    const hearts = [];
    for (let i = 0; i < N; i++) {
      const size = 14 + Math.random() * 28;
      const dur = 12 + Math.random() * 10;
      const color = i % 3 === 0 ? 'var(--coral)' : 'var(--pink)';
      const opacity = (0.35 + Math.random() * 0.45).toFixed(2);
      hearts.push({
        style: {
          width: `${size}px`,
          height: `${size}px`,
          left: `${Math.random() * 100}vw`,
          animationDuration: `${dur}s`,
          animationDelay: `${-Math.random() * dur}s`,
          color,
          opacity,
        },
      });
    }
    this.hearts = hearts;
  },
  methods: {
    openSignup() {
      this.$eventHub.$emit('viluu-landing:open-signup', { mode: 'register' });
    },
  },
};
</script>
<style scoped lang="scss">
.nav {
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 40px;
  max-width: 1480px;
  margin: 0 auto;
  gap: 14px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-right: auto;
  -webkit-tap-highlight-color: transparent;
}

.logo img {
  display: block;
  height: 24px;
  width: auto;
}

@media (max-width: 900px) {
  .nav {
    padding: 18px 22px;
    flex-wrap: wrap;
    gap: 12px;
  }
}

.err-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  line-height: normal;
}

.err-main {
  flex: 1;
  position: relative;
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  text-align: center;
}

.drift {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 1;
  overflow: hidden;
}

.drift .h {
  position: absolute;
  color: var(--pink);
  opacity: 0;
  animation: drift 14s linear infinite;
  filter: drop-shadow(0 6px 14px rgba(198, 62, 124, 0.35));
}

.drift .h svg {
  display: block;
}

.err-glyph {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 18px;
  line-height: 0.9;
  user-select: none;
  perspective: 800px;
}

.err-glyph .d {
  font-family: var(--display);
  font-weight: 800;
  font-size: clamp(140px, 22vw, 260px);
  letter-spacing: -0.05em;
  background: linear-gradient(135deg, var(--pink) 0%, var(--coral) 50%, #ff9166 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  filter: drop-shadow(0 24px 40px rgba(198, 62, 124, 0.35));
  position: relative;
  display: inline-block;
}

.err-glyph .d.left {
  animation: wobL 6s ease-in-out infinite;
}

.err-glyph .d.right {
  animation: wobR 6s ease-in-out infinite;
}

.err-glyph .d::before,
.err-glyph .d::after {
  content: attr(data-d);
  position: absolute;
  left: 0;
  top: 0;
  background: inherit;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  pointer-events: none;
}

.err-glyph .d::before {
  opacity: 0.35;
  transform: translate(-3px, 0);
  animation: glitch 5s steps(2, end) infinite;
  mix-blend-mode: multiply;
}

.err-glyph .d::after {
  opacity: 0.25;
  transform: translate(3px, 0);
  animation: glitch 5s steps(2, end) infinite reverse;
  mix-blend-mode: multiply;
}

.err-heart {
  position: relative;
  width: clamp(140px, 22vw, 260px);
  height: clamp(140px, 22vw, 260px);
  display: grid;
  place-items: center;
}

.err-heart svg {
  width: 88%;
  height: 88%;
  color: var(--pink);
  filter: drop-shadow(0 24px 40px rgba(198, 62, 124, 0.45));
  animation: beatErr 2.2s ease-in-out infinite;
}

.err-heart .crack {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  pointer-events: none;
}

.err-heart .crack svg {
  width: 88%;
  height: 88%;
  color: #fff;
  animation: cracker 4s ease-in-out infinite;
  filter: none;
}

.err-heart .sparkle {
  position: absolute;
  color: var(--coral);
  animation: spk 4s ease-in-out infinite;
}

.err-heart .sp1 {
  top: 6%;
  right: -2%;
  font-size: 24px;
  animation-delay: -1s;
}

.err-heart .sp2 {
  bottom: 14%;
  left: -4%;
  font-size: 18px;
  animation-delay: -2s;
}

.err-heart .sp3 {
  top: 42%;
  right: -8%;
  font-size: 14px;
  animation-delay: -3s;
}

.err-h1 {
  font-family: var(--display);
  font-size: clamp(28px, 4vw, 46px);
  font-weight: 700;
  letter-spacing: -0.025em;
  line-height: 1.1;
  margin: 24px 0 12px;
  text-wrap: balance;
  max-width: 680px;
}

.err-h1 .grad {
  background: linear-gradient(135deg, var(--pink) 0%, var(--coral) 60%, #ff9166 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-style: italic;
  font-weight: 600;
}

.err-sub {
  font-size: 17px;
  line-height: 1.55;
  color: var(--ink-dim);
  margin: 0 0 32px;
  max-width: 520px;
  text-wrap: pretty;
}

.err-actions {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 36px;
}

.err-actions .btn-primary {
  font-weight: 600;
  font-size: 15px;
  color: #fff;
  background: var(--brand-grad);
  border: none;
  padding: 16px 26px;
  border-radius: 999px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 14px 30px -8px rgba(255, 59, 127, 0.5);
  text-decoration: none;
  transition: transform 0.25s, box-shadow 0.25s;
}

.err-actions .btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 20px 40px -10px rgba(255, 59, 127, 0.65);
}

.err-actions .btn-primary .arrow {
  transition: transform 0.3s;
}

.err-actions .btn-primary:hover .arrow {
  transform: translateX(4px);
}

.err-actions .btn-ghost {
  font-weight: 600;
  font-size: 15px;
  color: var(--ink);
  background: #fff;
  border: 1px solid var(--line);
  padding: 16px 24px;
  border-radius: 999px;
  cursor: pointer;
  text-decoration: none;
  transition: border-color 0.2s, transform 0.2s;
}

.err-actions .btn-ghost:hover {
  border-color: rgba(198, 62, 124, 0.4);
  transform: translateY(-2px);
}

/* The global landing.scss forces .btn-primary to width:100% below 720px.
   404.html keeps its buttons at their natural width, so we opt out here. */
@media (max-width: 720px) {
  .err-actions .btn-primary {
    width: auto;
  }
}

.err-quick {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 460px;
  width: 100%;
  padding: 24px;
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 22px;
  box-shadow: 0 14px 32px -16px rgba(26, 12, 20, 0.15);
  text-align: left;
}

.err-quick h6 {
  font-family: var(--sans);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--ink-mute);
  margin: 0 0 12px;
}

.err-quick a {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 14px;
  border-radius: 12px;
  color: var(--ink);
  font-size: 14.5px;
  font-weight: 500;
  text-decoration: none;
  transition: background 0.15s ease;
}

.err-quick a:hover {
  background: #fff5ec;
}

.err-quick a .arr {
  color: var(--pink);
  font-weight: 700;
  transition: transform 0.2s;
}

.err-quick a:hover .arr {
  transform: translateX(4px);
}

.err-foot {
  position: relative;
  z-index: 5;
  padding: 24px 24px 30px;
  text-align: center;
  font-size: 12px;
  color: var(--ink-mute);
  border-top: 1px solid var(--line);
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(8px);
}

.err-foot a {
  color: var(--ink-mute);
  text-decoration: none;
  margin: 0 10px;
}

.err-foot a:hover {
  color: var(--pink);
}

.err-foot .err-foot-sep {
  margin: 0 10px;
}

@media (prefers-reduced-motion: reduce) {
  .err-glyph .d,
  .err-heart svg,
  .err-heart .sparkle,
  .drift .h {
    animation: none !important;
  }
  .err-glyph .d::before,
  .err-glyph .d::after {
    display: none;
  }
}

@keyframes drift {
  0% {
    transform: translate(0, 110vh) rotate(-20deg);
    opacity: 0;
  }

  8% {
    opacity: 0.7;
  }

  50% {
    opacity: 0.85;
  }

  92% {
    opacity: 0.5;
  }

  100% {
    transform: translate(40px, -12vh) rotate(20deg);
    opacity: 0;
  }
}

@keyframes wobL {
  0%,
  100% {
    transform: rotate(-3deg) translateY(0);
  }

  50% {
    transform: rotate(-1deg) translateY(-6px);
  }
}

@keyframes wobR {
  0%,
  100% {
    transform: rotate(3deg) translateY(0);
  }

  50% {
    transform: rotate(1deg) translateY(-6px);
  }
}

@keyframes glitch {
  0%,
  90%,
  100% {
    opacity: 0;
  }

  91%,
  93% {
    opacity: 0.5;
    transform: translate(-4px, 1px);
  }

  94%,
  96% {
    opacity: 0.35;
    transform: translate(3px, -1px);
  }
}

@keyframes beatErr {
  0%,
  100% {
    transform: scale(1) rotate(-2deg);
  }

  25% {
    transform: scale(1.06) rotate(-1deg);
  }

  50% {
    transform: scale(1) rotate(2deg);
  }

  75% {
    transform: scale(1.04) rotate(0);
  }
}

@keyframes cracker {
  0%,
  55%,
  100% {
    opacity: 0.8;
  }

  60%,
  80% {
    opacity: 1;
  }
}

@keyframes spk {
  0%,
  100% {
    opacity: 0;
    transform: scale(0.5) rotate(0);
  }

  40%,
  60% {
    opacity: 1;
    transform: scale(1) rotate(30deg);
  }
}
</style>
